import { useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { useQuery } from 'react-query';

import { apiClient } from '../../api/client/apiClient';

import { INTEGRATIONS_API_URL, INTEGRATIONS_HISTORY_QUERY } from './consts';
import { Integration } from './types';

interface RunHistoryProps {
  integration: Integration;
}

const columns = [
  { title: 'name', dataIndex: 'name', key: 'sheetName' },
  { title: 'status', dataIndex: 'status', key: 'status' },
  { title: 'startDate', dataIndex: 'startDate', key: 'startDate' },
  { title: 'endDate', dataIndex: 'endDate', key: 'endDate' },
];

export const RunHistory = ({ integration }: RunHistoryProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const query = useQuery(
    INTEGRATIONS_HISTORY_QUERY,
    async () => {
      const result = await apiClient.get(`${INTEGRATIONS_API_URL}/get-workflow-status/${integration.uuid}`);
      return result.data;
    },
    { enabled: false },
  );
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
    query.refetch();
  };

  return (
    <>
      <Button onClick={showModal}>See history</Button>
      <Modal
        title="See history"
        width={'auto'}
        visible={isModalVisible}
        onCancel={handleCancel}
        okButtonProps={{ style: { display: 'none' } }}
      >
        <Table
          loading={query.isLoading}
          dataSource={query.data}
          columns={columns}
          rowKey="id"
          size="middle"
          pagination={false}
        />
      </Modal>
    </>
  );
};
